import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import { Button, Tooltip } from '@mui/material';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useLoadLatestRange } from '../../../../hooks/range/useLoadLatestRange';
import { useRangeIsLatest } from '../../../../hooks/range/useRangeIsLatest';
import { useStreamUserDefinedRange } from '../../../../stores/stream-screen.store';

/**
 * V2 of LoadLatest: MUI button to jump to the current stream time.
 * Disabled when already on latest or when isDisabled (e.g. loading).
 * Uses custom green #00AC77 for the button.
 */
export function LoadLatestControl({ isDisabled = false }: { isDisabled?: boolean }) {
  const capture = usePostHogCapture();
  const { to } = useStreamUserDefinedRange();
  const isUpdated = useRangeIsLatest();
  const loadLatestStream = useLoadLatestRange();
  const disabled = isDisabled || isUpdated;

  const handleClick = () => {
    const now = Date.now();
    const minutesBehindLive =
      to != null ? Math.round(moment(now).diff(moment(to), 'minutes')) : null;

    capture('logger:jumped_to_latest', {
      old_to: new Date(to).toISOString(),
      new_to: new Date(now).toISOString(),
      minutes_behind_live: minutesBehindLive,
    });

    loadLatestStream();
  };

  return (
    <Tooltip
      title={
        disabled ? (
          ''
        ) : (
          <FormattedMessage
            id="logger.streamScreen.controls.loadLatestBtn"
            defaultMessage="Ir a la emisión actual"
          />
        )
      }
    >
      <Button
        data-testid="logger-stream-jump-to-latest"
        variant="contained"
        size="large"
        disabled={disabled}
        onClick={handleClick}
        sx={{
          px: 2,
          backgroundColor: '#00AC77',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#009966',
          },
        }}
      >
        <SkipNextIcon />
      </Button>
    </Tooltip>
  );
}
